import organizations from './organizations.json';

export const ORGANIZATIONS = organizations;
